class Api {
  constructor() {
    this.baseUrl = "https://api.ouropreto.genteufv.com.br/";
    //this.baseUrl = "http://localhost:5000/"; // Usar um enumerate
  }

  getDistritos(path) {
    return [
      "Todos",
      "Amarantina",
      "Antônio Pereira",
      "Cachoeira do Campo",
      "Engenheiro Corrêa",
      "Glaura",
      "Miguel Burnier",
      "Ouro Preto",
      "Lavras Novas",
      "Rodrigo Silva",
      "Santa Rita de Ouro Preto",
      "São Bartolomeu",
      "Santo Antônio do Leite",
      "Santo Antônio do Salto",
    ];
  }
  // ============================================== Rotas da página inicial ===================================================================================
  async getPropCadastrada(distrito) {
    const result = await this.getRouteInformation(
      "propCadastrada",
      distrito,
      "Erro ao buscar propriedades cadastradas: ",
    );

    return result;
  }

  async getPropProduzindo(distrito) {
    const result = await this.getRouteInformation(
      "propProduzindo",
      distrito,
      "Erro ao buscar propriedades produzindo: ",
    );

    return result;
  }

  async getPropNProduzindo(distrito) {
    const result = await this.getRouteInformation(
      "propNaoProduzindo",
      distrito,
      "Erro ao buscar propriedades não produzindo: ",
    );

    return result;
  }

  async getImoveisPorProdAgropec(distrito) {
    const result = await this.getRouteInformation(
      "contarProducaoAgropecuaria",
      distrito,
      "Erro ao buscar imoveis por produção agropecuária: ",
    );

    return result;
  }

  async getAreaMediaDistrito(distrito) {
    const result = await this.getRouteInformation(
      "areaMediaDistrito",
      distrito,
      "Erro ao buscar área média do distrito: ",
    );

    return result;
  }

  async getAreaMediaDistritoEducacao(
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
  ) {
    const result = await this.getRouteInformationEducation(
      "areaMediaEducacao",
      distrito,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      "Erro ao buscar área média do distrito: ",
    );

    return result;
  }

  async getAreaMediaSocial(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "areaMediaSocial",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar área média do distrito: ",
    );

    return result;
  }

  async getAreaMediaAmbiental(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "areaMediaAmbiental",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar área média do distrito: ",
    );

    return result;
  }

  async getAreaMediaDistritoInfra(
    distrito,
    situacaoEstradas,
    manutencaoEstradas,
  ) {
    const result = await this.getRouteInformationInfra(
      "areaMediaInfra",
      distrito,
      situacaoEstradas,
      manutencaoEstradas,
      "Erro ao buscar área média do distrito: ",
    );

    return result;
  }

  async getAreaMediaDistritoObra(
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
  ) {
    const result = await this.getRouteInformationObra(
      "areaMediaObra",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar área média do distrito: ",
    );

    return result;
  }

  async getGerenciaPropriedade(
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
  ) {
    const result = await this.getRouteInformationObra(
      "gerenciaPropriedade",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar dados de gerencia de propriedade: ",
    );

    return result;
  }

  async getMaoDeObra(distrito, gerenciaPropriedade, maoDeObra, organizacao) {
    const result = await this.getRouteInformationObra(
      "maoDeObra",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar dados de mão de obra: ",
    );

    return result;
  }

  async getOrganizacao(distrito, gerenciaPropriedade, maoDeObra, organizacao) {
    const result = await this.getRouteInformationObra(
      "organizacao",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar dados se possui organização: ",
    );

    return result;
  }

  async getImoveisPorDistrito() {
    const result = await this.getRouteInformation(
      "contarDistritos",
      "Todos",
      "Erro ao buscar imoveis por distrito: ",
    );

    return result;
  }

  // ============================================== Rotas da natureza de produção ===================================================================================
  async getNaturezaProd(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "naturezaProducao",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getContarProducao(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "contarProducao",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar a contagem de produção: ",
    );

    return result;
  }

  async getNumeroPropriedades(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "numeroPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesAgroturismo(
    distrito,
    agroturismo,
    interesseAgroturismo,
    dificuldadeAgroturismo,
    formaRenda,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "numeroPropriedadesAgroturismo",
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaRenda,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesSaude(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "numeroPropriedadesSaude",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesEducacao(
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
  ) {
    const result = await this.getRouteInformationEducation(
      "numeroPropriedadesEducacao",
      distrito,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesSocial(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "numeroPropriedadesSocial",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesAmbiental(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "numeroPropriedadesAmbiental",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesInfra(
    distrito,
    situacaoEstradas,
    manutencaoEstradas,
  ) {
    const result = await this.getRouteInformationInfra(
      "numeroPropriedadesInfra",
      distrito,
      situacaoEstradas,
      manutencaoEstradas,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getNumeroPropriedadesObra(
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
  ) {
    const result = await this.getRouteInformationObra(
      "numeroPropriedadesObra",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getAreaMediaAgroturismo(
    distrito,
    agroturismo,
    interesseAgroturismo,
    dificuldadeAgroturismo,
    formaRenda,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "areaMediaAgroturismo",
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaRenda,
      "Erro ao buscar area média de propriedades: ",
    );

    return result;
  }

  async getAreaMaxima(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "areaMaximaPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      null,
      null,
      null,
      null,
      null,
      null,
      "Erro ao buscar área máxima: ",
    );

    return result;
  }

  async getProdMaxima(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "prodMax",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      null,
      null,
      null,
      null,
      null,
      null,
      "Erro ao buscar área máxima: ",
    );

    return result;
  }

  async getAreaMedia(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "areaMediaPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar área média: ",
    );

    return result;
  }

  async getNumeroPropriedades2(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "numeroPropriedades2",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar numero de propriedades: ",
    );

    return result;
  }

  async getAreaMedia2(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "areaMediaPropriedades2",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar área média: ",
    );

    return result;
  }

  async getProducaoEmKg(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "prodTotal",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar a produção total: ",
    );

    return result;
  }

  async getProducaoMedia(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "producaoMedia",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar a produção média: ",
    );

    return result;
  }

  // ============================================== Rotas da página condições gerais ===================================================================================
  async getPossuiCarro(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "possuiCarro",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      null,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar dados de propriedades que possuem carro: ",
    );
    return result;
  }

  async getEnergiaEletrica(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "energiaEletrica",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      null,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar dados de propriedades que possuem energia elétrica: ",
    );
    return result;
  }

  async getAbastecimentoAgua(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "abastecimentoAgua",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      null,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar dados de propriedades que possuem abastecimento de água: ",
    );
    return result;
  }

  async getCaptacaoAgua(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "captacaoAgua",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar dados de captação de água: ",
    );
    return result;
  }

  async getLocalizacaoPropriedades(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "dadosPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedades2(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "dadosPropriedades2",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedades3(distrito) {
    const result = await this.getRouteInformation(
      "dadosPropriedades3",
      distrito,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesEducacao(
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
  ) {
    const result = await this.getRouteInformationEducation(
      "dadosPropriedadesEducacao",
      distrito,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesAgroturismo(
    distrito,
    agroturismo,
    interesseAgroturismo,
    dificuldadeAgroturismo,
    formaDeRenda,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "dadosPropriedadesAgroturismo",
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaDeRenda,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesSaude(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "dadosPropriedadesSaude",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesSocial(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "dadosPropriedadesSocial",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesAmbiental(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "dadosPropriedadesAmbiental",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesInfra(
    distrito,
    situacaoEstradas,
    manutencaoEstradas,
  ) {
    const result = await this.getRouteInformationInfra(
      "dadosPropriedadesInfra",
      distrito,
      situacaoEstradas,
      manutencaoEstradas,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getLocalizacaoPropriedadesObra(
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
  ) {
    const result = await this.getRouteInformationObra(
      "dadosPropriedadesObra",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar localização das propriedades: ",
    );
    return result?.value;
  }

  async getTipoFossa(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    descarteLixo,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "tipoFossa",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      null,
      descarteLixo,
      descarteEsgoto,
      "Erro ao buscar dados de tipo de fossa: ",
    );

    return result;
  }

  async getDescarteLixo(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteEsgoto,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "descarteLixo",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      null,
      descarteEsgoto,
      "Erro ao buscar dados de descarte de lixo: ",
    );

    return result;
  }

  async getDescarteEsgoto(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
  ) {
    const result = await this.getRouteInformationWithFilters(
      "descarteEsgoto",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprio,
      energiaEletrica,
      abastecimentoAgua,
      tipoFossa,
      descarteLixo,
      null,
      "Erro ao buscar dados de descarte de esgoto: ",
    );

    return result;
  }

  async getAgroturismo(
    distrito,
    interesseAgroturismo,
    dificuldadeAgroturismo,
    formaRenda,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "agroturismo",
      distrito,
      null,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaRenda,
      "Erro ao buscar dados de agroturismo: ",
    );

    return result;
  }

  async getFormaDeRenda(
    distrito,
    agroturismo,
    interesseAgroturismo,
    dificuldadeAgroturismo,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "formaDeRenda",
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      null,
      "Erro ao buscar dados de forma de renda: ",
    );

    return result;
  }

  async getDificuldadeAgroturismo(
    distrito,
    agroturismo,
    interesseAgroturismo,
    formaRenda,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "dificuldadeAgroturismo",
      distrito,
      agroturismo,
      interesseAgroturismo,
      null,
      formaRenda,
      "Erro ao buscar dados de dificuldades em agroturismo: ",
    );

    return result;
  }

  async getInteresseAgroturismo(
    distrito,
    agroturismo,
    dificuldadeAgroturismo,
    formaRenda,
  ) {
    const result = await this.getRouteInformationAgritourism(
      "interesseAgroturismo",
      distrito,
      agroturismo,
      null,
      dificuldadeAgroturismo,
      formaRenda,
      "Erro ao buscar dados de interesse em agroturismo: ",
    );

    return result;
  }

  async getNivelEscolaridade(
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
  ) {
    const result = await this.getRouteInformationEducation(
      "nivelEscolaridade",
      distrito,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      "Erro ao buscar dados de nível de escolaridade: ",
    );

    return result;
  }

  async getMatriculaEscola(
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
  ) {
    const result = await this.getRouteInformationEducation(
      "matriculaEscola",
      distrito,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      "Erro ao buscar dados de matricula em escola: ",
    );

    return result;
  }

  async getQualidadeEscolasRurais(
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
  ) {
    const result = await this.getRouteInformationEducation(
      "qualidadeEscolasRurais",
      distrito,
      nivelEscolaridade,
      matriculaEscola,
      qualidadeEscolasRurais,
      "Erro ao buscar dados de qualidade em escolas rurais: ",
    );

    return result;
  }

  async getRendaExclusiva(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "rendaExclusiva",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de renda exclusiva: ",
    );

    return result;
  }

  async getCreditoRural(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "creditoRural",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de credito rural: ",
    );

    return result;
  }

  async getPossuiEmpresa(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "possuiEmpresa",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados quem possui empresa: ",
    );

    return result;
  }

  async getRendaPrincipalRural(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "rendaPrincipalRural",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de renda principal rural: ",
    );

    return result;
  }

  async getMaiorDificuldade(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "maiorDificuldade",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de dificuldades: ",
    );

    return result;
  }

  async getEmpreendedorismo(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "empreendedorismo",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de empreendedorismo: ",
    );

    return result;
  }

  async getRecebeRecursos(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "recebeRecursos",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de recebimento de recursos: ",
    );

    return result;
  }

  async getAtividadePrincipal(
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
  ) {
    const result = await this.getRouteInformationSocial(
      "atividadeRural",
      distrito,
      rendaExclusiva,
      creditoRural,
      possuiEmpresa,
      rendaPrincipal,
      dificuldade,
      empreendedorismo,
      recebeRecursos,
      atividadeRural,
      "Erro ao buscar dados de atividade principal rural: ",
    );

    return result;
  }

  async getFrequenciaExame(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "frequenciaExame",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de frequencia de exames: ",
    );

    return result;
  }

  async getAtendimentoAmbulancia(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "atendimentoAmbulancia",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de atendimento de ambulância: ",
    );

    return result;
  }

  async getSistemaSaude(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformation(
      "sistemaSaude",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de sistema de saúde: ",
    );

    return result;
  }

  async getUsoMedicamento(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "usoMedicamentos",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de possui doenças crônicas: ",
    );

    return result;
  }

  async getDificuldadeAtendimento(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformation(
      "dificuldadeAgendamento",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de possui doenças crônicas: ",
    );

    return result;
  }

  async getQualidadeSSMunicipal(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformation(
      "qualidadeSaudeMunicipal",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de possui doenças crônicas: ",
    );

    return result;
  }

  async getQualidadeSSRural(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "qualidadeSaudeRural",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de possui doenças crônicas: ",
    );

    return result;
  }

  async getPossuiDoencasCronicas(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "possuiDoencasCronicas",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de possui doenças crônicas: ",
    );

    return result;
  }

  async getTipoDoencasCronicas(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "doencasCronicas",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de tipo de doenças crônicas: ",
    );

    return result;
  }

  async getProgramaSaudeRural(
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
  ) {
    const result = await this.getRouteInformationHealth(
      "programaSaudeRural",
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      "Erro ao buscar dados de programa de saúde rural: ",
    );

    return result;
  }

  async getNascentes(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "nascentes",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar dados de nascentes: ",
    );

    return result;
  }

  async getNumeroNascentes(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "numeroNascentes",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar número de nascentes: ",
    );

    return result;
  }

  async getAguaCorrente(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "aguaCorrente",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar dados de água corrente: ",
    );

    return result;
  }

  async getMata(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "mata",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar dados de mata: ",
    );

    return result;
  }

  async getTipoMata(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "tipoMata",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar dados de tipo de mata: ",
    );

    return result;
  }

  async getAgrotoxico(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "agrotoxico",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar dados de uso de agrotóxico: ",
    );

    return result;
  }

  async getProblemasSaudeAgrotoxico(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
  ) {
    const result = await this.getRouteInformationAmbiental(
      "problemasSaudeAgrotoxico",
      distrito,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      "Erro ao buscar dados de problemas de saúde causados pelos agrotóxicos: ",
    );

    return result;
  }

  async getSituacaoEstradas(distrito, situacaoEstradas, manutencaoEstradas) {
    const result = await this.getRouteInformationInfra(
      "situacaoEstradas",
      distrito,
      situacaoEstradas,
      manutencaoEstradas,
      "Erro ao buscar dados de situação de estradas: ",
    );

    return result;
  }

  async getManutencaoEstradas(distrito, situacaoEstradas, manutencaoEstradas) {
    const result = await this.getRouteInformationInfra(
      "manutencaoEstradas",
      distrito,
      situacaoEstradas,
      manutencaoEstradas,
      "Erro ao buscar dados de manutenção de estradas: ",
    );

    return result;
  }

  async getInfraestrutura(distrito, situacaoEstradas, manutencaoEstradas) {
    const result = await this.getRouteInformationInfra(
      "infraestrutura",
      distrito,
      situacaoEstradas,
      manutencaoEstradas,
      "Erro ao buscar dados de infraestrutura: ",
    );

    return result;
  }

  async getProdutosFabricados(distrito) {
    const result = await this.getRouteInformation(
      "produtosFabricados",
      distrito,
      "Erro ao buscar dados de produtos fabricados: ",
    );

    return result;
  }

  async getAssistenciaTecnica(
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
  ) {
    const result = await this.getRouteInformationObra(
      "assistenciaTecnica",
      distrito,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      "Erro ao buscar dados de assistência técnica: ",
    );

    return result;
  }

  async getRouteInformation(route, distrito, errorMsg) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationWithFilters(
    route,
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprio,
    energiaEletrica,
    abastecimentoAgua,
    tipoFossa,
    descarteLixo,
    descarteEsgoto,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (category) {
      url.searchParams.append("categoria", category);
    }

    if (subcategoria) {
      url.searchParams.append("subcategoria", subcategoria);
    }

    if (natureza) {
      url.searchParams.append("natureza", natureza);
    }

    if (inscricao) {
      url.searchParams.append("inscricao", inscricao);
    }

    if (proprietario) {
      url.searchParams.append("proprietario", proprietario);
    }

    if (carroProprio) {
      url.searchParams.append("carroProprio", carroProprio);
    }

    if (energiaEletrica) {
      url.searchParams.append("energiaEletrica", energiaEletrica);
    }

    if (abastecimentoAgua) {
      url.searchParams.append("abastecimentoAgua", abastecimentoAgua);
    }

    if (tipoFossa) {
      url.searchParams.append("tipoFossa", tipoFossa);
    }

    if (descarteLixo) {
      url.searchParams.append("descarteLixo", descarteLixo);
    }

    if (descarteEsgoto) {
      url.searchParams.append("descarteEsgoto", descarteEsgoto);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationWithFiltersAndLimits(
    route,
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (category) {
      url.searchParams.append("categoria", category);
    }

    if (subcategoria) {
      url.searchParams.append("subcategoria", subcategoria);
    }

    if (natureza) {
      url.searchParams.append("natureza", natureza);
    }

    if (inscricao) {
      url.searchParams.append("inscricao", inscricao);
    }

    if (proprietario) {
      url.searchParams.append("proprietario", proprietario);
    }

    if (
      areaMin != null &&
      areaMax != null &&
      areaMin >= 0 &&
      areaMax >= areaMin
    ) {
      url.searchParams.append("areaMin", areaMin);
      url.searchParams.append("areaMax", areaMax);
    }

    if (
      prodMin != null &&
      prodMax != null &&
      prodMin >= 0 &&
      prodMax >= prodMin
    ) {
      url.searchParams.append("prodMin", prodMin);
      url.searchParams.append("prodMax", prodMax);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationEducation(
    route,
    distrito,
    nivelEscolaridade,
    matriculaEscola,
    qualidadeEscolasRurais,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (nivelEscolaridade) {
      url.searchParams.append("nivelEscolaridade", nivelEscolaridade);
    }

    if (matriculaEscola) {
      url.searchParams.append("matriculaEscola", matriculaEscola);
    }

    if (qualidadeEscolasRurais) {
      url.searchParams.append("qualidadeEscolasRurais", qualidadeEscolasRurais);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationAgritourism(
    route,
    distrito,
    agroturismo,
    interesseAgroturismo,
    dificuldadeAgroturismo,
    formaRenda,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (agroturismo) {
      url.searchParams.append("agroturismo", agroturismo);
    }

    if (interesseAgroturismo) {
      url.searchParams.append("interesseAgroturismo", interesseAgroturismo);
    }

    if (dificuldadeAgroturismo) {
      url.searchParams.append("dificuldadeAgroturismo", dificuldadeAgroturismo);
    }

    if (formaRenda) {
      url.searchParams.append("formaDeRenda", formaRenda);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationHealth(
    route,
    distrito,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (frequenciaExame) {
      url.searchParams.append("frequenciaExame", frequenciaExame);
    }

    if (atendimentoAmbulancia) {
      url.searchParams.append("atendimentoAmbulancia", atendimentoAmbulancia);
    }

    if (sistemaSaude) {
      url.searchParams.append("sistemaSaude", sistemaSaude);
    }

    if (usoMedicamento) {
      url.searchParams.append("usoMedicamento", usoMedicamento);
    }

    if (dificuldadeAtendimento) {
      url.searchParams.append("dificuldadeAtendimento", dificuldadeAtendimento);
    }

    if (possuiDoencaCronica) {
      url.searchParams.append("possuiDoencaCronica", possuiDoencaCronica);
    }

    if (tipoDoencaCronica) {
      url.searchParams.append("tipoDoencaCronica", tipoDoencaCronica);
    }

    if (programaSaudeRural) {
      url.searchParams.append("programaSaudeRural", programaSaudeRural);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationAmbiental(
    route,
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (nascentes) {
      url.searchParams.append("nascentes", nascentes);
    }

    if (aguaCorrente) {
      url.searchParams.append("aguaCorrente", aguaCorrente);
    }

    if (mata) {
      url.searchParams.append("mata", mata);
    }

    if (agrotoxico) {
      url.searchParams.append("agrotoxico", agrotoxico);
    }

    if (problemaSaudeAgrotoxico) {
      url.searchParams.append(
        "problemasSaudeAgrotoxico",
        problemaSaudeAgrotoxico,
      );
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationSocial(
    route,
    distrito,
    rendaExclusiva,
    creditoRural,
    possuiEmpresa,
    rendaPrincipal,
    dificuldade,
    empreendedorismo,
    recebeRecursos,
    atividadeRural,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (rendaExclusiva) {
      url.searchParams.append("rendaExclusiva", rendaExclusiva);
    }

    if (creditoRural) {
      url.searchParams.append("creditoRural", creditoRural);
    }

    if (possuiEmpresa) {
      url.searchParams.append("possuiEmpresa", possuiEmpresa);
    }

    if (rendaPrincipal) {
      url.searchParams.append("rendaPrincipal", rendaPrincipal);
    }

    if (dificuldade) {
      url.searchParams.append("dificuldade", dificuldade);
    }

    if (empreendedorismo) {
      url.searchParams.append("empreendedorismo", empreendedorismo);
    }

    if (recebeRecursos) {
      url.searchParams.append("recebeRecursos", recebeRecursos);
    }

    if (atividadeRural) {
      url.searchParams.append("atividadeRural", atividadeRural);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationInfra(
    route,
    distrito,
    situacaoEstradas,
    manutencaoEstradas,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (situacaoEstradas) {
      url.searchParams.append("situacaoEstradas", situacaoEstradas);
    }

    if (manutencaoEstradas) {
      url.searchParams.append("manutencaoEstradas", manutencaoEstradas);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationObra(
    route,
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
    errorMsg,
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (gerenciaPropriedade) {
      url.searchParams.append("gerenciaPropriedade", gerenciaPropriedade);
    }

    if (maoDeObra) {
      url.searchParams.append("maoDeObra", maoDeObra);
    }

    if (organizacao) {
      url.searchParams.append("organizacao", organizacao);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }
}

// Exporta uma instância única (singleton)
const apiInstance = new Api();
export default apiInstance;
